/* ScalperIntel — sticky add-to-cart bar (Phase 8).

   Two jobs:
   1. Reveal logic — IntersectionObserver on `.product-form__buttons`
      (the wrapper around Dawn's original Add to Cart button). When the
      target scrolls ABOVE the viewport (user has scrolled past it), the
      sticky bar slides in. When the target is back in view or below
      (user hasn't reached it yet), the bar hides.

   2. Variant sync — listen for `change` on the hidden `<input name="id">`
      that Dawn updates on every variant switch. Look up the new variant's
      {title, price, image} in the data island embedded by the snippet,
      and swap the bar content with a 150ms fade. */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initSticky(root) {
    var dataEl = root.querySelector('script[type="application/json"][data-si-sticky-data]');
    if (!dataEl) return;

    var map = {};
    try {
      map = JSON.parse(dataEl.textContent) || {};
    } catch (e) {
      return;
    }

    var sectionId = root.getAttribute('data-section-id');
    var formId = 'product-form-' + sectionId;
    var form = document.getElementById(formId);
    if (!form) return;

    // The target the IntersectionObserver watches: Dawn's existing buy
    // buttons wrapper. When this scrolls above the viewport, the user
    // has passed the original ATC and the sticky should appear.
    var target = form.querySelector('.product-form__buttons');
    if (!target) return;

    var thumb   = root.querySelector('[data-si-sticky-thumb]');
    var variant = root.querySelector('[data-si-sticky-variant]');
    var price   = root.querySelector('[data-si-sticky-price]');
    var cta     = root.querySelector('[data-si-sticky-cta]');

    // ---- reveal logic ----------------------------------------------------

    function show() {
      root.classList.add('is-visible');
      root.setAttribute('aria-hidden', 'false');
    }
    function hide() {
      root.classList.remove('is-visible');
      root.setAttribute('aria-hidden', 'true');
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // Original ATC is visible → hide sticky.
            hide();
          } else if (entry.boundingClientRect.top < 0) {
            // Original ATC is ABOVE the viewport → user scrolled past it.
            show();
          } else {
            // Original ATC is BELOW the viewport → user hasn't reached it.
            hide();
          }
        });
      }, { rootMargin: '0px 0px 0px 0px', threshold: 0 });
      io.observe(target);
    } else {
      // No IntersectionObserver (very old browsers) — always show the sticky.
      show();
    }

    // ---- variant sync ----------------------------------------------------

    function update(variantId) {
      var key = String(variantId);
      var entry = Object.prototype.hasOwnProperty.call(map, key) ? map[key] : null;
      if (!entry) return;

      root.classList.add('is-updating');
      window.setTimeout(function () {
        if (variant) variant.textContent = entry.title || '';
        if (price)   price.textContent   = entry.price || '';
        if (thumb && entry.image) {
          thumb.setAttribute('src', entry.image);
          if (entry.image2x) {
            thumb.setAttribute(
              'srcset',
              entry.image + ' 1x, ' + entry.image2x + ' 2x'
            );
          }
          if (entry.alt) thumb.setAttribute('alt', entry.alt);
        }
        if (cta) {
          if (entry.available === false) {
            cta.setAttribute('disabled', 'disabled');
            cta.setAttribute('aria-disabled', 'true');
          } else {
            cta.removeAttribute('disabled');
            cta.removeAttribute('aria-disabled');
          }
        }
        root.classList.remove('is-updating');
      }, 150);
    }

    function onInputChange(e) {
      var input = e.target;
      if (!input || input.name !== 'id') return;
      var id = parseInt(input.value, 10);
      if (!id) return;
      update(id);
    }

    form.addEventListener('change', onInputChange);
  }

  ready(function () {
    document.querySelectorAll('[data-si-sticky]').forEach(initSticky);
  });
})();
